import React, {useState} from "react";
import axios from "axios";
import { API_BASE_URL } from '../config';

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/contact`, formData);
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      alert("Error sending message. Please try again.");
      console.error(error);
    }
  };

  return (
    <section style={{ margin: "3rem 5rem" }}>
      <h1 className="centered-subtitle">Contact</h1>
      <section className="flex-container-contact">
        
        <article>
          <form className="contact-form" onSubmit={handleSubmit}>
            <label>Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />

            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />

            <label>Phone</label>
            <input placeholder="(Optional)" type="tel" name="phone" value={formData.phone} onChange={handleChange} />

            <label>Message</label>
            <textarea name="message" value={formData.message} onChange={handleChange} rows="4" required></textarea>

            <button type="submit">Send Message</button>
          </form>
        </article>
        <article>
          <h3 style={{ margin: "1rem 0" }}>We want to hear you!</h3>
          <p>Feel free to send us a message and we'll get to you ASAP!</p>
          <div className="contact-method">          
            <a href="mailto:info@castillobc.shop"><i className="bi bi-envelope"></i>info@castillobc.shop</a>
          </div>
          <div className="contact-method">          
            <a href="tel:8558622324"><i className="bi bi-phone"></i>855-862-2324</a>
          </div>
          <div className="contact-method">          
            <a href="https://www.facebook.com/profile.php?id=61585253246452#"><i className="bi bi-facebook"></i>Castillo Botanicals & Crystals</a>
          </div>
          <div className="contact-method">          
            <a href="https://www.instagram.com/castillobcshop/"><i className="bi bi-instagram"></i>castillobcshop</a>
          </div>
          
        </article>
      </section>


    </section>
  );
}

export default Contact;